import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Underline = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M8.565 0c.62 0 1.122.5 1.122 1.119V23.73c0 6.78 5.512 12.275 12.313 12.275 6.8 0 12.313-5.495 12.313-12.275V1.12A1.12 1.12 0 0 1 35.435 0c.62 0 1.122.5 1.122 1.119V23.73c0 8.016-6.517 14.513-14.557 14.513S7.443 31.746 7.443 23.73V1.12A1.12 1.12 0 0 1 8.565 0ZM6.8 42.881a1.12 1.12 0 0 1 1.122-1.118h28.156c.62 0 1.122.5 1.122 1.118A1.12 1.12 0 0 1 36.078 44H7.922c-.62 0-1.122-.5-1.122-1.119Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
Underline.displayName = 'Underline';
Underline.defaultProps = {
  'aria-label': 'Underline'
};
export default Underline;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Editor/Underline.js
// module id = 3564
// module chunks = 11